import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CrudService } from "./crud.service";
import { Startups } from "../models/startups";

@Injectable({
  providedIn: "root",
})
export class StartupsService extends CrudService<Startups, number> {
  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/startups`);
  }

  public checkDomainRating(domain: string): Observable<any> {
    return this._http
      .get<any>(
        `${environment.baseUrl}/domain_rating/check?domain=${encodeURIComponent(domain)}`,
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  public extractDomain(url: string): string {
    if (!url) {
      return "";
    }
    try {
      let value = url.trim();
      if (!/^https?:\/\//i.test(value)) {
        value = "http://" + value;
      }
      return new URL(value).hostname.replace(/^www\./i, "");
    } catch {
      return url
        .replace(/^https?:\/\//i, "")
        .replace(/^www\./i, "")
        .split("/")[0];
    }
  }
}
